import React from "react";
import avatar from "../assets/Avatar.png";

const Avatar = () => {
  return (
    <>
      <div className="flex justify-center">
        <img height={50} src={avatar} alt="" />
      </div>
    </>
  );
};

export default Avatar;
